import { createAxiosInstance } from '../axios';
export class AbstractFacade {
    constructor(config, interceptors = {}) {
        if (!config.axiosConfig || !config.axiosConfig.baseURL) {
            throw new Error(`"${this.constructor.name}": undefined config.axiosConfig.baseURL`);
        }
        this.client = createAxiosInstance(config, interceptors);
    }
    getFormDataHeaders(formData) {
        return typeof formData.getHeaders === 'function' ? formData.getHeaders() : { 'content-type': 'multipart/form-data' };
    }
}
//# sourceMappingURL=AbstractFacade.js.map